import PageSizeDropdown from './PageSizeDropdown';

export default PageSizeDropdown;
